var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 44.877 44.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_721",
    "data-name": "\\u7EC4 721",
    transform: "translate(-3205.718 -395.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_327",
    "data-name": "\\u8DEF\\u5F84 327",
    d: "M3226.754,395.4h2.805c.749.1,1.5.168,2.248.3a22.519,22.519,0,0,1,18.443,18.278c.145.816.231,1.642.345,2.464v2.8a2.573,2.573,0,0,0-.073.338,21.413,21.413,0,0,1-3.065,9.664,22.182,22.182,0,0,1-15.438,10.691c-.813.153-1.64.231-2.46.343h-2.805c-.548-.067-1.1-.126-1.642-.2a22.53,22.53,0,0,1-19.045-18.325c-.15-.829-.234-1.671-.349-2.507v-2.8c.067-.548.124-1.1.2-1.644a22.522,22.522,0,0,1,18.371-19.048C3225.107,395.6,3225.933,395.515,3226.754,395.4Zm7.358,10.263a.511.511,0,0,0-.139-.046c-1.62.013-3.248-.071-4.857.068a4.405,4.405,0,0,0-4.051,3.177,9.781,9.781,0,0,0-.381,2.361c-.063.913-.015,1.835-.015,2.8h-2.533v4.617h2.546v12.967h5.416v-13h3.641l.468-4.585h-4.121v-2.443c0-1.172.335-1.5,1.519-1.5h2.507Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookOutlined);
export default __webpack_public_path__ + "static/media/facebook_outlined.94fd30f5b46cec829a2829da5cb76215.svg";
export { ForwardRef as ReactComponent };